import { service } from './service'; // 模板列表

export function List(data) {
  return service({
    url: 'SysReportTpl/List',
    data: data,
    method: 'post'
  });
} // 新增模板

export function Add(data) {
  return service({
    url: 'SysReportTpl/Add',
    data: data,
    method: 'post'
  });
} // 获取模板id

export function GetReportID(params) {
  return service({
    url: 'SysReportTpl/GetReportID',
    params: params,
    method: 'get'
  });
} // 删除模板

export function DeleteTemplate(id) {
  return service({
    url: "SysReportTpl/Delete?id=".concat(id),
    method: 'post'
  });
}